var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"table-header"},[(_vm.isSortColumn)?_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.toggleSort()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.headerText)}}),_c('font-awesome-icon',{attrs:{"icon":['fad', _vm.sortIcon]}})],1):_c('span',{domProps:{"innerHTML":_vm._s(_vm.headerText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }